import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { formatPrice } from "../../../utils";
import { queryBuilder } from "../../../api/utils";
import config from "../../../config"; //
// Components
//

import { useEnquireForm } from "../../EnquiryForm";
import Button from "../../Button";
import Icon from "../../Icon";
import "./ReleaseNavigation.scss";
var showPriceNextToLotOnly = config.otherOptions.get("masterplan.show_price_next_to_lot_only"),
    showPriceNextToLot = config.otherOptions.get("masterplan.show_price_next_to_lot"),
    showPrice = !showPriceNextToLotOnly && showPriceNextToLot;
export var ReleaseNavigation = function ReleaseNavigation(a) {
  var b = a.menu,
      c = a.title,
      d = a.hovered,
      e = a.onMouseEnter,
      f = a.onMouseLeave,
      g = useEnquireForm(),
      h = useState({}),
      i = _slicedToArray(h, 2),
      j = i[0],
      k = i[1],
      l = useState("frontage-desc"),
      m = _slicedToArray(l, 2),
      n = m[0],
      o = m[1];

  return b = queryBuilder(b, {
    sort: n
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "release--sorting"
  }, /*#__PURE__*/React.createElement("label", {
    className: "release--sorting--label"
  }, "Sort By"), /*#__PURE__*/React.createElement("div", {
    className: "release--sorting--select"
  }, /*#__PURE__*/React.createElement("select", {
    value: n,
    onChange: function onChange(a) {
      var b = a.target.value;
      o(b);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "frontage-desc"
  }, "Frontage High"), /*#__PURE__*/React.createElement("option", {
    value: "frontage"
  }, "Frontage Low"), /*#__PURE__*/React.createElement("option", {
    value: "area-desc"
  }, "Land Size High"), /*#__PURE__*/React.createElement("option", {
    value: "area"
  }, "Land Size Low")))), /*#__PURE__*/React.createElement("ul", null, b.map(function (a, b) {
    var c = a.name,
        h = a.slug,
        i = a.href,
        l = a.image,
        m = a.status,
        n = a.area,
        o = a.frontage,
        p = a.packages,
        q = a.price,
        r = a.flyer,
        s = classnames({
      active: h === d,
      isActive: j[h]
    });
    return /*#__PURE__*/React.createElement("li", {
      key: "release-nav-".concat(b),
      className: classnames(s, "lfs--navitem"),
      onMouseEnter: function onMouseEnter() {
        return e(h);
      },
      onMouseLeave: function onMouseLeave() {
        return f(h);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "lfs--navitem--wrapper"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "lfs--navitem--thumb",
      to: i,
      style: {
        display: "block"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: l.url,
      alt: c
    })), /*#__PURE__*/React.createElement("div", {
      className: "lfs--navitem--content",
      onClick: function toggleFilter() {
        k(_defineProperty({}, h, !j[h]));
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "lfs--navitem--title"
    }, c), /*#__PURE__*/React.createElement("span", {
      className: classnames("lfs--navitem--status", {
        hold: 4 === m
      })
    }, showPrice && 4 !== m ? q ? formatPrice(q) : "" : config.status.get(m)), /*#__PURE__*/React.createElement("span", {
      className: "lfs--navitem--specs"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lfs--navitem--landsize"
    }, /*#__PURE__*/React.createElement("span", null, "Land Size "), n, "m\xB2"), /*#__PURE__*/React.createElement("span", {
      className: "lfs--navitem--frontage"
    }, /*#__PURE__*/React.createElement("span", null, "Frontage "), o ? /*#__PURE__*/React.createElement(React.Fragment, null, o, "m") : "n/a"), /*#__PURE__*/React.createElement("span", {
      className: "lfs--navitem--packages"
    }, /*#__PURE__*/React.createElement("span", null, "Packages "), p && p.length || 0))), /*#__PURE__*/React.createElement("div", {
      className: "lfs--navitem--c2a"
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      className: "enquire",
      onClick: function onClick() {
        return g(a);
      }
    }, "Enquire"), /*#__PURE__*/React.createElement(Button, {
      size: "small",
      href: i,
      color: "secondary"
    }, "View Lot"), /*#__PURE__*/React.createElement("a", {
      href: r,
      target: "_BLANK",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "download"
    })))));
  })));
};
export default ReleaseNavigation;